"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntl = exports.provideIntl = void 0;
var vue_1 = require("vue");
var injection_key_1 = require("./injection-key");
function provideIntl(intl) {
    vue_1.provide(injection_key_1.intlKey, intl);
}
exports.provideIntl = provideIntl;
function useIntl() {
    var intl = vue_1.inject(injection_key_1.intlKey);
    if (!intl) {
        throw new Error("An intl object was not injected. Install the plugin or use provideIntl.");
    }
    return intl;
}
exports.useIntl = useIntl;
